"use strict";
import "lodash";
import { svc_fetchAll, svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { svc_getTerminals } from "@/services/staff";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";

const endpointBasePrefix = "terminals";

const Model = {
	namespace: "m_Terminals",
	state: {
		terminals: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { terminals } }) {
			logger(`** Terminals reducers response ${JSON.stringify(terminals)}`, 5);
			return { ...state, terminals };
		},
	},
	effects: {
		*fetchAll({ searchKey }, { call, put }) {
			let terminals = yield call(svc_search, endpointBasePrefix, searchKey);
			if (!showServerResponse(terminals, false)) return;
			_.forEach(terminals, function (row) {
				row.key = row.id;
			});
			yield put({
				type: "handleFetchAll",
				payload: { terminals },
			});

			return terminals;
		},
		// newer fetch all with filtering of user scope
		*fetchAllWithScope({ brandId, outletId, scopeToken, saveToState = true }, { call, put }) {
			let terminals = yield call(svc_search, endpointBasePrefix, { brand: brandId, outlet: outletId });

			_.forEach(terminals, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["enrolment_date"]);
				if (outletId && !scopeToken.allowedDerivedOutlets.includes(outletId)) row.disableEdit = true;
				if (brandId && !outletId && !scopeToken.allowedBrands.includes(brandId)) row.disableEdit = true;
			});

			if (saveToState) {
				yield put({
					type: "handleFetchAll",
					payload: { terminals },
				});
			}

			return terminals;
		},
		// for xero purposes incase something breaks
		*fetchSelectXREF({ payload }, { call, put }) {
			if (payload.upos_outlet_id) payload = payload.upos_outlet_id;
			if (payload.outlet_id) payload = payload.outlet_id;
			const terminals = yield call(svc_search, endpointBasePrefix, { outlet: payload });
			if (!showServerResponse(terminals, false)) return;
			_.forEach(terminals, function (row) {
				row.key = row.id;
				row.terminalDescription = `${row.terminal_no} - ${row.description}`;
			});

			return terminals;
		},
		*addTerminal({ payload }, { call, put }) {
			payload = _.omit(payload, ["id", "uuid", "key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			showServerResponse(response);
			return response;
		},
		*updateTerminal({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
				showServerResponse(response);
                return response;
			}
		},
		*deleteTerminal({ payload }, { call, put }) {
			if (payload && payload.id) {
				payload = _.omit(payload, ["key"]);
				const response = yield call(svc_deleteOne, endpointBasePrefix, payload, "id");
				showServerResponse(response);
                return response;
			}
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			/*return history.listen(({ pathname, query }) => {
				if (pathname === "/menu") {
					dispatch({ type: "fetchAll", payload: query });
				}
			});*/
		},
	},
};

export default Model;
